import { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay";
import { Spinner } from "react-bootstrap";

export default function ProcessingOverlay({
  children,
  pending = false,
  global = false,
  spinner = true,
  text = 'กำลังดำเนินการ\nโปรดรอสักครู่...'
}) {
  LoadingOverlay.propTypes = undefined // fix the 'failed prop type' warning
  const [counter, setCounter] = useState(0);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= 768
  );

  useEffect(() => {
    if (!pending) {
      setCounter(0);
      return;
    }

    const timer = setInterval(() => {
      setCounter(c => c + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [pending]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const boxStyle = {
    padding: isMobile ? "16px 24px" : "20px 32px",
    background: "#fff",
    borderRadius: 8,
    textAlign: "center",
    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.2)",
  };

  const SpinnerComponent = spinner ? (
    <Spinner
      animation="border"
      variant="danger"
      style={{ 
        width: 50, 
        height: 50, 
        borderWidth: 5,
      }}
    />
  ) : false;

  if (global) {
    if (!pending) return null;

    return (
      <div style={globalStyle}>
        <div style={boxStyle}>
          {SpinnerComponent}
          {text && (
            <div style={textStyle}>{text}</div>
          )}
        </div>
      </div>
    );
  }

  return (
    <LoadingOverlay
      active={pending}
      spinner={SpinnerComponent}
      text={text}
      styles={overlayStyles}

    >
      {children}
    </LoadingOverlay>
  );
}

const globalStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
  fontFamily: '"Noto Sans Thai", sans-serif',
  fontSize: '14px',
};

const textStyle = {
  marginTop: 12,
  fontSize: 14,
  color: '#14181C',
  whiteSpace: "pre-line",
};

const overlayStyles = {
  overlay: base => ({
    ...base,
    background: "rgba(255, 255, 255, 0.2)",
    // display: "inline-block",
  }),
  content: base => ({
    ...base,
    color: "#333"
  })
};
